module.exports = __webpack_public_path__ + "static/media/coffefree.acd0905a.png";